var render = function render(){var _vm=this,_c=_vm._self._c;return _c('models',{staticClass:"ifconnect",attrs:{"showmodel":_vm.showconnect,"title":_vm.title,"canceltext":_vm.canceltext,"confirmtext":_vm.confirmtext,"needcancel":_vm.needcancel},on:{"confirm":_vm.closeifconnect,"closemodel":_vm.closeifconnect}},[_c('div',[_c('p',[_vm._v(" 开启同步操作，则操作任意一台云手机，会将操作同步至本组中已勾选的云手机！ ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }